import { render, staticRenderFns } from "./CertificationIndex.vue?vue&type=template&id=ed5a0460&scoped=true&"
import script from "./CertificationIndex.vue?vue&type=script&lang=js&"
export * from "./CertificationIndex.vue?vue&type=script&lang=js&"
import style0 from "./CertificationIndex.vue?vue&type=style&index=0&id=ed5a0460&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5a0460",
  null
  
)

export default component.exports